import { render, staticRenderFns } from "./arrow-right-outlined.vue?vue&type=template&id=7b8e18c7&scoped=true&"
var script = {}
import style0 from "./arrow-right-outlined.vue?vue&type=style&index=0&id=7b8e18c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8e18c7",
  null
  
)

export default component.exports